import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface Wheelchair_BoardingAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  condition?: string;
  description?: string;
  tenant: OD3_Tenant;
  value: number;
}

export class Wheelchair_Boarding extends Parse.Object<Wheelchair_BoardingAttributes> {
  static className: string = "OD3_GTFS_Wheelchair_Boarding";

  constructor(data?: Partial<Wheelchair_BoardingAttributes>) {
    super(
      "OD3_GTFS_Wheelchair_Boarding",
      data as Wheelchair_BoardingAttributes
    );
  }

  get condition(): string | undefined {
    return super.get("condition");
  }
  set condition(value: string | undefined) {
    super.set("condition", value);
  }
  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
  get value(): number {
    return super.get("value");
  }
  set value(value: number) {
    super.set("value", value);
  }
}

Parse.Object.registerSubclass(
  "OD3_GTFS_Wheelchair_Boarding",
  Wheelchair_Boarding
);
